import React, { createContext } from "react";

import "./Advants.css";

function Advants() {
  return (
    <div className="advants">
        <div className="advants__items">
          <div className="advants__title">ПРЕИМУЩЕСТВА ДКМ СИСТЕМЫ</div>
          <div className="advant__hidden-title"></div>
          <div className="advant__hidden3"></div>
          <div className="advant1">
            <p className="advant__title">Собственное производство</p>
            <p className="advant__text">
              Промышленная площадка в Калужской области, план строительства производственных цехов
              рассчитан на изготовление и испытания насосов с мощностью 2МВт
            </p>
          </div>
          <div className="advant2">
            <p className="advant__title">Программа подбора</p>
            <p className="advant__text">
              Собственная разработка программы подбора насосов позволяет удобно, быстро и качественно
              выбирать подходящее решение под индивидуальные нужды
            </p>
          </div>
          <div className="advant__hidden2"></div>
          <div className="advant__hidden4"></div>
          <div className="advant3">
            <p className="advant__title">Индивидуальный подход</p>
            <p className="advant__text">
              Мы развиваемся и расширяем для Вас зоны доставки и профессиональную сборку оборудования
              непосредственно на месте эксплуатации.
            </p>
          </div>
          <div className="advant__hidden3"></div>
          <div className="advant__hidden"></div>
          <div className="advant__hidden"></div>
          <div className="advant4">
            <p className="advant__title">НИОКР</p>
            <p className="advant__text">
              Разработка гидравлических частей насосов при участии специалистов из ведущих технических вузов
              в РФ с учетом современных требований по показателям эффективности и надежности
            </p>
          </div>
          <div className="advant__hidden4"></div>
          <div className="advant__hidden2"></div>
          <div className="advant5">
            <p className="advant__title">Высокий уровень качества</p>
            <p className="advant__text">
              Для удобства общения и быстрого решения поставленных задач,
              мы наладили систему клиентского сервиса.
            </p>
          </div>
          <div className="advant6">
            <p className="advant__title">Конкурентное ценообразование</p>
            <p className="advant__text">
              Мы используем передовые методы производства, со строгим контролем качества на различных
              этапах, что позволяет нам гарантировать высокое качество продукции.
            </p>
          </div>
        </div>
        <div className="advants__items">
        </div>
        <div className="advants__items">
        </div>
    </div>
  );
}

export default Advants;
